import React from "react";

import { ApolloProvider, } from "react-apollo";
import { BrowserRouter, } from "react-router-dom";

import styled, {
	ThemeProvider,
	injectGlobal,
} from "styled-components";

import { client, } from "../../apolloClient";
import theme from "../../theme";

import Sidebar from "./sidebar";

//------------------------------

const Container = styled.div`
	flex-direction: row;
	width: 100%;
	height: 100%;
`;

const defaultTheme = theme;
const defaultClient = client;
const defaultRouter = BrowserRouter;

//------------------------------

class Shell extends React.Component{
	constructor(props){
		super(props);
		/* eslint no-unused-expressions: 0 */

		injectGlobal`
			html, body, #root {
				width: 100% ;
				height: 100% ;
				margin: 0;
			}

			body {
				font-family: Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif;
				color: ${ props.theme.colors.black };
			}

			div {
				display: flex;
				flex-direction: column;
			}

			h1, h2, h3, h4, h5, h6, p {
				margin: 0;
			}
		`;
	}

	render(){
		const Router = this.props.router;

		return (
			<ThemeProvider theme = { this.props.theme } >
				<ApolloProvider client = { this.props.client } >
					<Router>
						<Container>
							<Sidebar differentiateUserAndOrg = { this.props.differentiateUserAndOrg } />
							{ this.props.children }
						</Container>
					</Router>
				</ApolloProvider>
			</ThemeProvider>
		);
	}
};

Shell.defaultRouter = defaultRouter;
Shell.defaultClient = defaultClient;
Shell.defaultTheme = defaultTheme;

Shell.defaultProps = {
	router: defaultRouter,
	client: defaultClient,
	theme: defaultTheme,
};

export default Shell;
